import api from './api.js'

const CACHE_KEY = 'legal_documents_cache'
const CACHE_TTL_MS = 24 * 60 * 60 * 1000 // 24 horas

export async function getLegalDocuments() {
  try {
    const cached = localStorage.getItem(CACHE_KEY)
    if (cached) {
      const { data, expiresAt } = JSON.parse(cached)
      if (Date.now() < expiresAt) {
        return data
      }
    }
  } catch {
    localStorage.removeItem(CACHE_KEY)
  }

  const response = await api.get('/legal/documents')
  const data = response.data.documents || []

  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      data,
      expiresAt: Date.now() + CACHE_TTL_MS
    }))
  } catch {
    // localStorage cheio — ignora silenciosamente
  }

  return data
}

export function clearLegalDocumentsCache() {
  localStorage.removeItem(CACHE_KEY)
}

export async function uploadLegalDocument(docType, file) {
  const formData = new FormData()
  formData.append('doc_type', docType)
  formData.append('file', file)
  const response = await api.post('/admin/legal/documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  clearLegalDocumentsCache()
  return response.data
}
